/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import cx from "classnames";
import React, { useCallback } from "react";

import { usePlayerTranslation } from "../../../shared/context/PlayerTranslationContext";
import { useDeviceType } from "../../../shared/hooks/useDeviceType";
import CastDeviceIcon from "../../../shared/icons/player/CastDevice.svg";
import { usePlayerCastState, usePlayerPlayingState } from "../../Controller";
import { ClosePlayerButton, Controller } from "../../Interface";
import { SceenicOverlay } from "../../Plugins";
import { useOverlayState } from "../OverlayStateContext";

import { usePlayerOverlayVisibility } from "./usePlayerOverlayVisibility";

import "./Container.scss";

export const PlayingOverlay = () => {
  const { t } = usePlayerTranslation();
  const { togglePlay } = usePlayerPlayingState();
  const { isCastConnected, castDeviceName } = usePlayerCastState();

  const { settings } = useOverlayState();
  const { isVisible, onMouseMove } = usePlayerOverlayVisibility();
  const { isMobilePhoneDevice, iPadDevice } = useDeviceType();

  const onClick = useCallback(
    () => !settings && !isMobilePhoneDevice && !iPadDevice && togglePlay(),
    [iPadDevice, isMobilePhoneDevice, settings, togglePlay],
  );

  return (
    <div
      className={cx(
        "OverlayContainer",
        isCastConnected && "OverlayContainer--cast",
      )}
      data-visible={isVisible}
      onMouseMove={onMouseMove}
    >
      <div className="OverlayContainer__TopSection" data-visible={isVisible}>
        <ClosePlayerButton />
      </div>
      <div className="OverlayContainer__CenterSection" onClick={onClick}>
        <SceenicOverlay key="SceenicOverlay" />
        {isCastConnected && (
          <div className="OverlayContainer__CastSection">
            <p>{t("PLAYER_TOOLTIP_CHROMECAST_CONNECTED_TO")}</p>
            <p>
              <CastDeviceIcon aria-hidden="true" focusable="false" />
              <strong>{castDeviceName}</strong>
            </p>
          </div>
        )}
      </div>
      <div className="OverlayContainer__BottomSection" data-visible={isVisible}>
        <Controller />
      </div>
    </div>
  );
};
